import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Button, Modal, ModalBody, Label, Collapse, Card, CardBody} from 'reactstrap';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import './RegisterOrgByAnchorModal.css';
import {CURRENCIES} from "../../../constants/constants";
import { Utils } from '../../../utils/utils';

class RegisterOrgByAnchorModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenBankInfo: false
        };
    }

    render() {
        if (_.isNil(this.props.pricingData)) {
            return null;
        }

        return (
            <Modal className='register-org-modal' isOpen={this.props.isOpen} toggle={this.props.onCancel}>
                <ModalBody>
                    <Label className="register-org-modal-label">
                        {_.get(this.props.translation, 'register_org.register_org_by_anchor_alert')}
                    </Label>
                    <Label className="register-org-modal-label">
                        {_.get(this.props.translation, 'payment.annual_license_cost_label') + ': '}
                        <b>{this.props.pricingData.annualFee.amount}{CURRENCIES[this.props.pricingData.annualFee.currency]}</b>
                    </Label>
                    <Label className="register-org-modal-label">
                        {_.get(this.props.translation, 'payment.wire_label') + ' '}
                        {_.get(this.props.translation, 'payment.account_id_label').replace("{iban}", _.get(Utils.getBankDataByCountry(this.props.orgCountryCode, this.props.translation), 'iban_number')) + ' '}
                        {_.get(this.props.translation, 'payment.create_account_label') + ' '}
                        <b>{_.get(this.props.translation, 'payment.create_account_message_label').replace("{orgName}", this.props.orgName)}</b>
                        <IconContainer
                            className="payment-info-icon"
                            icon='info'
                            onClick={this.toggle}
                            title={_.get(this.props.translation, 'payment.bank_details_label')}
                        />
                        <Collapse className="payment-info-collapse" isOpen={this.state.isOpenBankInfo}>
                            <Card>
                                <CardBody>
                                    <h6>{_.get(this.props.translation, 'payment.about_us_label')}</h6>
                                    <i>{_.get(this.props.translation, 'payment.bank_data_label')}</i><br/>
                                    <div className="bank-data-container">
                                        {_.get(Utils.getBankDataByCountry(this.props.orgCountryCode, this.props.translation), 'bank_data')}
                                    </div>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </Label>
                    <Label className="register-org-modal-label">
                        {_.get(this.props.translation, 'register_org.register_org_by_anchor_hint')}
                    </Label>
                    <div className="modal-buttons-container">
                        <Button color="secondary"
                                onClick={this.props.onCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                        <Button className="olive-green-btn"
                                onClick={this.props.onProceed}>{_.get(this.props.translation, 'register_org.proceed_button')}</Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    toggle = () => {
        this.setState({isOpenBankInfo: !this.state.isOpenBankInfo});
    }
}

RegisterOrgByAnchorModal.propTypes = {
    translation: PropTypes.object,
    orgName: PropTypes.string.isRequired,
    orgCountryCode: PropTypes.string.isRequired,
    pricingData: PropTypes.object,
    onCancel: PropTypes.func,
    onProceed: PropTypes.func
};

export default RegisterOrgByAnchorModal;


// WEBPACK FOOTER //
// ./src/components/organizationManagement/registerOrgByAnchorModal/RegisterOrgByAnchorModal.js